export default "/images/table-view.svg?d7709b03802f87c5dbd2129d2b6c1d1f";